import { formatCurrency } from '@angular/common';

export const iqCurrencyRoundRange = (low: number, high: number): string => {
    return `(${iqCurrencyRound(low)} - ${iqCurrencyRound(high)})`;
};
export const iqCurrencyRound: (num: number) => string = (num: number): string =>
    formatCurrency(Math.round(num), 'en-US', '$').split('.')[0];
export const iqCurrency: (num: number) => string = (num: number): string =>
    formatCurrency(num, 'en-US', '$', 'USD', '1.2-2');
